import { z } from 'zod'

export const ACCEPTED_FILE_TYPES_TWO = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
]

export const formSchema = z.object({
  pitch_deck_user: z
    .instanceof(File)
    .optional()
    .nullable()
    .refine((file) => !file || ACCEPTED_FILE_TYPES_TWO.includes(file.type), {
      message: 'Only image files (.jpeg, .jpg, .png) are accepted',
    })
    .refine(
      (file) => !file || file.size <= 5_000_000, // 5MB limit
      {
        message: 'File size must be less than 5MB',
      }
    ),
})

export type IncubationFormSchema = z.infer<typeof formSchema>
